import React, { useEffect, useState } from 'react';

function initialsFromTitle(title) {
  const words = String(title || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return 'CE';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/** Barra superior tipo scoreboard: identidad del cuadro + reloj de hora local. */
export function BracketTopBar({ title, subtitle }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');

  return (
    <div className="bracket-topbar">
      <div className="bracket-topbar-brand">
        <span className="bracket-topbar-badge">{initialsFromTitle(title)}</span>
        <span className="bracket-topbar-titles">
          <span className="bracket-topbar-title">{title}</span>
          {subtitle ? <span className="bracket-topbar-subtitle">{subtitle}</span> : null}
        </span>
      </div>
      <div className="bracket-topbar-clock">
        <span className="bracket-topbar-time">
          {hh}:{mm}
          <span className="bracket-topbar-secs">:{ss}</span>
        </span>
        <span className="bracket-topbar-clocklabel">HORA LOCAL</span>
      </div>
    </div>
  );
}

/** Franja inferior con los próximos partidos (hora · fase · campo). */
export function BracketFieldStrip({ matches }) {
  if (!Array.isArray(matches) || matches.length === 0) return null;
  return (
    <div className="bracket-fieldstrip">
      {matches.map((m, i) => (
        <div className="bracket-fieldstrip-item" key={`fs-${i}`}>
          <span className="bracket-fieldstrip-time">{m.time}</span>
          <span className="bracket-fieldstrip-name">{m.label}</span>
          {m.field ? <span className="bracket-fieldstrip-field">{m.field}</span> : null}
        </div>
      ))}
    </div>
  );
}
